<template>
    <div id="history_line" >
        <svg width="240" height="60"> <!--start image -->
            <g> <!-- group image-->
                <polyline points="20,20 20,30 20,25
                      90,25 90,20 90,30 90,25
                      170,25 170,20 170,30 170,25
                      230,25 230,20 230,30"
                          :style="linestyle" /> <!-- draw time line -->
                <text x="20" y="50" fill="black" text-anchor="middle">nu</text>
                <text x="90" y="50" fill="black" text-anchor="middle">1wk</text>
                <text x="170" y="50" fill="black" text-anchor="middle">1mnd</text>
                <text x="230" y="50" fill="black" text-anchor="middle">1jr</text>
                <circle cx="20" cy="25" r="4" stroke="red" stroke-width="1" fill="red"/> <!-- first circle, this event -->

                <g v-for ="(event, i) in events" :key="i"> <!-- rest of the events (fill array from database!!!) -->
                    <circle :cx="event.cx" cy="25" r="4" stroke="red" stroke-width="1" fill="red" fill-opacity="0.3"/>
                </g>
            </g>
        </svg> <!--end image -->
        <v-img v-if="chevron" src="./../assets/chevron_right.png" class="justify-end some-icon"></v-img>



    </div>
</template>

<script>
    import axios from "axios";
    import config from "@/config/config";

    export default {
        name: "TimeComponent.vue",
        data() {
            return {
                xnow: 20, // time line xcoordinaten
                xwk: 90,
                xmn: 170,
                xyr: 240,
                linestyle: 'fill:none;stroke:grey;stroke-width:2',
                events: [
                    {days:     1, cx: 20},
                    {days:     2, cx: 20},
                    {days:     3, cx: 20},
                    {days:     4, cx: 20},
                    {days:     5, cx: 20},
                    {days:     7, cx: 20},
                    {days:    14, cx: 20},
                    {days:    21, cx: 20},
                    {days:    28, cx: 20},
                    {days:    30, cx: 20},
                    {days:    60, cx: 20},
                    {days:    90, cx: 20},
                    {days:   120, cx: 20},
                    {days:   150, cx: 20},
                    {days:   180, cx: 20},
                    {days:   210, cx: 20},
                    {days:   240, cx: 20},
                    {days:   270, cx: 20},
                    {days:   300, cx: 20},
                    {days:   330, cx: 20},
                    {days:   360, cx: 20},
                ]
            }
        },
        methods: {
            CalcEventX: function (){ // uitrekenen x coordinaten adv het tijdsverschil tussen de events
                for (let i = 0; i < this.events.length; i++) {
                    if (this.events[i].days <= 7)        {this.events[i].cx = (this.events[i].xwk-this.xnow)*this.events[i].days     /7       + this.xnow}
                    else if (this.events[i].days <= 30)  {this.events[i].cx = (this.xmn-this.xwk) *(this.events[i].days-7) /(30-7)  +this.xwk}
                    else if (this.events[i].days <= 365) {this.events[i].cx = (this.xyr-this.xmn) *(this.events[i].days-30)/(365-30)+this.xmn}

                    if(this.events[i].cx < 20 || !this.events[i].cx) {
                        this.events[i].cx = 20
                    }
                }
            }
        },
        mounted() {
            axios
                .post(config.url +'/alarms/events', {filter: this.filter})
                .then((response) => {
                    this.events = response.data.events
                    this.CalcEventX()
                })
        },
        props: ['filter', 'chevron'],
        watch: {
            filter() {
                axios
                    .post(config.url +'/alarms/events', {filter: this.filter})
                    .then((response) => {
                        this.events = response.data.events
                        this.CalcEventX()
                    })
            }
        }
    }
</script>

<style scoped>
    v-img {
        padding: 50px;
    }
    .some-icon {
        height: 20px !important;
        width: 20px !important;
        float: right;
        margin-top: 20px;
        margin-right: 2px;
    }
</style>
